import { render, staticRenderFns } from "./accassDetail.vue?vue&type=template&id=95e07c48&"
import script from "./accassDetail.vue?vue&type=script&lang=js&"
export * from "./accassDetail.vue?vue&type=script&lang=js&"
import style0 from "./accassDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95e07c48')) {
      api.createRecord('95e07c48', component.options)
    } else {
      api.reload('95e07c48', component.options)
    }
    module.hot.accept("./accassDetail.vue?vue&type=template&id=95e07c48&", function () {
      api.rerender('95e07c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/components/accassDetail.vue"
export default component.exports